import { getIn } from "formik";
import { WintFormConnectProps, WintFormData, WintFormKey } from "models/propTypes/wintFormPropsTypes";

export default function connectToForm<T extends Record<string, any>>(
  formState: WintFormData<T>,
  name: WintFormKey<T>
): WintFormConnectProps {
  return {
    name,
    value: getIn(formState.values, name),
    onChange: formState.handleChange,
    onBlur: formState.handleBlur,
    setValue: (newValue: any, shouldValidate?: boolean) => formState.setFieldValue(name, newValue, shouldValidate),
    setTouched: (isTouched?: boolean, shouldValidate?: boolean) =>
      formState.setFieldTouched(name, isTouched, shouldValidate),
    touched: !!getIn(formState.touched, name),
    error: getIn(formState.errors, name),
    hasError: !!getIn(formState.touched, name) && !!getIn(formState.errors, name),

    get hasErrors(): boolean {
      return Object.keys(formState.errors[name] ?? {}).length > 0;
    },
    validate: () => formState.validateField(name),
  };
}
